import styled from 'styled-components';
import colors from '@designSystem/colors';
import typings from '@designSystem/typings';
import breakpoints from '@designSystem/breakpoints';

export const ResultContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: ${colors.lighterGrey};
  height: 100vh;
`;

export const CertificateNotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 40px;
  width: 320px;
  text-align: center;

  & > ${typings.Header} {
    margin-top: 40px;
  }

  & > ${typings.Paragraph} {
    font-weight: 400;
  }
`;

export const Container = styled.div`
  max-width: 736px;
  width: 100%;

  @media (max-width: ${breakpoints.large}) {
    width: auto;
  }
`;

export const CertificateContainer = styled.div`
  background: ${colors.white};
  border-radius: 10px;
  padding: 64px 64px 64px 0px;
  margin-top: 40px;

  @media (max-width: ${breakpoints.large}) {
    width: auto;
    padding: 40px 24px;
    margin-top: 16px;
  }
`;

export const HeaderLabel = styled(typings.HeaderLarge)`
  margin: 0;
  color: ${colors.green};
`;

export const Label = styled(typings.ParagraphSmallest)`
  margin: 0;
  color: ${colors.darkGrey};
`;

export const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${breakpoints.large}) {
    & > ${Label} {
      text-align: center;
    }
  }
`;

export const HeadingValue = styled(typings.Header)`
  margin: 0;
  color: ${colors.trueBlack};
`;

export const Value = styled(typings.Paragraph)`
  margin: 0;
  color: ${colors.black};
`;

const BaseRow = styled.div`
  display: flex;
  flex-direction: row;

  & > div {
    margin-left: 64px;
  }

  @media (max-width: ${breakpoints.large}) {
    flex-direction: column;

    & > div {
      margin-top: 16px;
      margin-left: 0px;
    }
  }
`;

export const HeadingRow = styled(BaseRow)`
  margin: 44px 0px;
`;

export const Row = styled(BaseRow)`
  margin: 20px 0px;
`;

export const FooterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0px;
  margin: 0px 24px;

  & > svg {
    height: 40px;
  }

  @media (max-width: ${breakpoints.large}) {
    width: auto;
  }
`;
